export default __webpack_public_path__ + "static/media/attention.bcdc4522.svg";